import Vue from "vue";
import Router from "vue-router";
import PaymentDip from "./views/PaymentDip.vue";
/* eslint-disable */

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home.vue"),
    },
    {
      path: "/informes",
      name: "informes",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Information.vue"),
    },
    {
      path: "/modelo-educativo",
      name: "editable",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/ModeloEducativo.vue"),
    },
    {
      path: "/inscripcion",
      name: "inscripcion",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Payment.vue"),
    },
    {
      path: "/inscripcion_diplomado",
      name: "inscripcion_diplomado",
      component: PaymentDip,
    },
    {
      path: "/covid19",
      name: "covid19",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Covid19.vue"),
    },
    {
      path: "/pago_exitoso",
      name: "pago_exitoso",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/PaymentSuccess.vue"),
    },
    {
      path: "/Derecho",
      name: "law",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Law.vue"),
    },
    {
      path: "/Administracion-de-empresas",
      name: "admon",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Admon.vue"),
    },
    {
      path: "/Ciencias-de-la-educacion",
      name: "education",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Education.vue"),
    },
    {
      path: "/Criminologia-y-criminalistica",
      name: "crimi",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Crimi.vue"),
    },
    {
      path: "/Contaduria",
      name: "contaduria",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Contaduria.vue"),
    },
    {
      path: "/Comercio",
      name: "comercio",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Comercio.vue"),
    },
    {
      path: "/faq",
      name: "faq",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AskFrequently.vue"),
    },
    {
      path: "/quejas-y-sugerencias",
      name: "quejas-y-sugerencias",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Quejas.vue"),
    },
    {
      path: "/diplomado",
      name: "diplomado",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Diplomados.vue"),
    },
    {
      path: "/aviso_de_privacidad",
      name: "aviso",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Aviso.vue"),
    },
    {
      path: "/sistema",
      name: "sistema",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/System.vue"),
    },
    {
      path: "/inscripciones",
      name: "inscripciones",
      component: () =>
        import(/* webpackChunkName: "inscripciones" */ "./views/Inscribete.vue"),
    },
    {
      path: "/gestion-logistica",
      name: "gestion-logistica",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Logistic.vue"),
    },
    {
      path: "/evaluacion-del-aprendizaje",
      name: "evaluacion-del-aprendizaje",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/LearningAssessment.vue"),
    },
    {
      path: "/estrategica-personal",
      name: "estategica personal",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/PersonalStrategic.vue"),
    },
    {
      path: "/gestion-capital-humano",
      name: "gestion-capital humano",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/HumanStrategic.vue"),
    },
    {
      path: "/salud-publica",
      name: "salud-publica",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Salud.vue"),
    },    
    {
      path: "/gracias-informes",
      name: "gracias-informes",
      component: () =>
        import(/* webpackChunkName: "Thankyou" */ "./views/Thankyou.vue"),
    },
    {
      path: "/maestria-en-educacion",
      name: "maestria-educacion",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/MaestriaEduacion.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
